import BankingIndustryLayout from './BankingIndustryLayout';
import InsuranceIndustryLayout from './InsuranceIndustryLayout';
import HealthcareIndustryLayout from './HealthcareIndustryLayout';
import LifeSciencesIndustryLayout from './LifeSciencesIndustryLayout';
import ConsumerTechIndustryLayout from './ConsumerTechIndustryLayout';
import IndustrialIndustryLayout from './IndustrialIndustryLayout';
import SoftwareHiTechLayout from './SoftwareHiTechLayout';
import TelecomMediaLayout from './TelecomMediaLayout';

const industryPageMap = {
    'banking-financial': BankingIndustryLayout,
    'insurance': InsuranceIndustryLayout,
    'healthcare': HealthcareIndustryLayout,
    'life-sciences': LifeSciencesIndustryLayout,
    'consumer-tech': ConsumerTechIndustryLayout,
    'industrial': IndustrialIndustryLayout,
    'software-hitech': SoftwareHiTechLayout,
    'telecom-media': TelecomMediaLayout,
};

export default industryPageMap;
